// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cC85Asox {
  position: fixed;
  top: 0;
  left: 50%;
  -webkit-transform: translateX(-50%) translateY(-100%);
          transform: translateX(-50%) translateY(-100%);
  z-index: 10000;
  -webkit-transition: -webkit-transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transition: -webkit-transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: none;
  width: 100%;
  max-width: 600px;
  padding: 0 16px;
  box-sizing: border-box;
}
.cC85Asox._DTF8t0K {
  -webkit-transform: translateX(-50%) translateY(20px);
          transform: translateX(-50%) translateY(20px);
}
.cpVJ3fop {
  background: rgba(0, 0, 0, 0.85);
  color: #ffffff;
  padding: 12px 20px;
  border-radius: 12px;
  font-size: 14px;
  line-height: 1.4;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
}
`, "",{"version":3,"sources":["webpack://./src/components/Message/Message.module.less"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,SAAA;EACA,qDAAA;UAAA,6CAAA;EACA,cAAA;EACA,uEAAA;EAAA,+DAAA;EAAA,uDAAA;EAAA,4GAAA;EACA,oBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AACF;AAEA;EACE,oDAAA;UAAA,4CAAA;AAAF;AAGA;EACE,+BAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,0CAAA;EACA,2BAAA;EACA,mCAAA;AADF","sourcesContent":[".messageContainer {\n  position: fixed;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%) translateY(-100%);\n  z-index: 10000;\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  pointer-events: none;\n  width: 100%;\n  max-width: 600px;\n  padding: 0 16px;\n  box-sizing: border-box;\n}\n\n.messageContainer.visible {\n  transform: translateX(-50%) translateY(20px);\n}\n\n.message {\n  background: rgba(0, 0, 0, 0.85);\n  color: #ffffff;\n  padding: 12px 20px;\n  border-radius: 12px;\n  font-size: 14px;\n  line-height: 1.4;\n  text-align: center;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messageContainer": `cC85Asox`,
	"visible": `_DTF8t0K`,
	"message": `cpVJ3fop`
};
export default ___CSS_LOADER_EXPORT___;
